// @ts-nocheck
import {
  FETCH_SUBSCRIPTION_FULFILLED,
  FETCH_SUBSCRIPTION_REJECTED,
  FETCH_SUBSCRIPTIONS_FULFILLED,
  FETCH_SUBSCRIPTIONS_REJECTED,
  FETCH_CHANNELS_FULFILLED,
  FETCH_CHANNELS_REJECTED,
  FETCH_PRODUCTS_FULFILLED,
  FETCH_PRODUCTS_REJECTED,
  DESELECT_SUBSCRIPTION,
  CHANGE_SUBSCRIPTION_FULFILLED,
  CLOSE_SUBSCRIPTION_FULFILLED,
  CLOSE_PARTNER_SUBSCRIPTION_FULFILLED,
  FETCH_DISCOUNT_REASONS_FULFILLED,
  FETCH_DISCOUNT_REASONS_REJECTED,
} from './subscriptionActionTypes';

const initialState = {
  subscriptions: null,
  subscriptionDetails: null,
  channels: null,
  products: null,
  discountReasons: null
};

export default function subscriptionReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SUBSCRIPTIONS_FULFILLED:
      return {
        ...state,
        subscriptions: action.payload,
      };
    case FETCH_SUBSCRIPTIONS_REJECTED:
      return {
        ...state,
        subscriptions: null,
      };
    case FETCH_SUBSCRIPTION_FULFILLED:
      return {
        ...state,
        subscriptionDetails: action.payload,
      };
    case FETCH_SUBSCRIPTION_REJECTED:
      return {
        ...state,
        subscriptionDetails: null,
      };
    case FETCH_CHANNELS_FULFILLED:
      return {
        ...state,
        channels: action.payload,
      };
    case FETCH_CHANNELS_REJECTED:
      return {
        ...state,
        channels: null,
      };
    case FETCH_PRODUCTS_FULFILLED:
      return {
        ...state,
        products: action.payload,
      };
    case FETCH_PRODUCTS_REJECTED:
      return {
        ...state,
        products: null,
      };
    case CHANGE_SUBSCRIPTION_FULFILLED:
      return {
        ...state,
        subscriptionDetails: action.payload,
      };
    case CLOSE_SUBSCRIPTION_FULFILLED:
      return {
        ...state,
        subscriptionDetails: action.payload,
      };
    case CLOSE_PARTNER_SUBSCRIPTION_FULFILLED:
      return {
        ...state,
        subscriptionDetails: action.payload,
      };
    case DESELECT_SUBSCRIPTION:
      return {
        ...state,
        subscriptionDetails: null,
      };
    case FETCH_DISCOUNT_REASONS_FULFILLED:
      return {
        ...state,
        discountReasons: action.payload,
      };
    case FETCH_DISCOUNT_REASONS_REJECTED:
      return {
        ...state,
        discountReasons: null,
      };
    default:
      return state;
  }
}
